import { ClerkProvider, useAuth } from '@clerk/clerk-react';
import { StrictMode, useEffect } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';
import { ErrorBoundary } from './components/ui/error-boundary';
import { ToastContainer } from './components/ui/toast-container';
import { ToastProvider } from './components/ui/toast-context';
import { initSentry, setSentryUser } from './sentry';
import { AppThemeProvider, GlobalStyles } from './theme';

initSentry();

// Expose app version in browser console (injected by Vite define at build time)
(window as unknown as Record<string, unknown>).__APP_VERSION__ = __APP_VERSION__;

// Fetch API version on startup (fire-and-forget)
const apiBase = import.meta.env.VITE_API_URL || '';
fetch(`${apiBase}/api/health`)
  .then((res) => res.json())
  .then((data: { version?: string }) => {
    if (data.version) {
      (window as unknown as Record<string, unknown>).__API_VERSION__ = data.version;
    }
  })
  .catch(() => {
    // Health check failure is non-critical
  });

function SentryUserSync() {
  const { userId } = useAuth();
  useEffect(() => {
    setSentryUser(userId ?? null);
  }, [userId]);
  return null;
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ClerkProvider publishableKey={import.meta.env.VITE_CLERK_PUBLISHABLE_KEY}>
      <SentryUserSync />
      <AppThemeProvider>
        <GlobalStyles />
        <ErrorBoundary>
          <ToastProvider>
            <App />
            <ToastContainer />
          </ToastProvider>
        </ErrorBoundary>
      </AppThemeProvider>
    </ClerkProvider>
  </StrictMode>,
);
